module.exports = "<div><div style=position:relative dropdown-kt details=return styling=small options=::options.cabinClasses model=params.CabinClass></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base/templates/flights/form_options/cabin_class_dropdown.tmpl.html
// module id = 3685
// module chunks = 0